module.exports = __webpack_public_path__ + "img/magazin_delo_about_us_3_mob.57984bdd.jpg";